document.addEventListener('DOMContentLoaded', function() {
  const showcase = document.querySelector('.images-showcase');
  if (!showcase) return;
  
  const container = showcase.querySelector('.images-showcase__container');
  const items = container ? container.querySelectorAll('.showcase-item') : [];
  if (items.length === 0) return;
  
  // Check if JavaScript is enabled
  showcase.classList.add('js-enabled');
  
  const middleIndex = Math.floor(items.length / 2);
  const middleItem = items[middleIndex];
  const middleImage = middleItem ? middleItem.querySelector('img') : null;
  
  // Track maximum spread achieved
  let maxSpreadAchieved = 0;
  let isResizing = false;
  let currentHeight = 0;
  let isInitialized = false;
  
  // Set initial state - ALL ITEMS HIDDEN AT FIRST
  function initializeItems() {
    items.forEach((item, index) => {
      // Initially hide all items
      item.style.opacity = '0';
      item.style.filter = 'blur(10px)';
      item.style.transform = 'translate(-50%, -50%)';
      item.style.zIndex = '1';
      item.style.pointerEvents = 'none';
    });
    
    // Only show middle item after height is calculated
    if (middleItem) {
      middleItem.style.opacity = '1';
      middleItem.style.filter = 'blur(10px)';
      middleItem.style.transform = 'translate(-50%, -50%)';
      middleItem.style.zIndex = '100';
    }
  }
  
  // Get accurate image dimensions for height calculation
  function getImageDimensions(img) {
    return new Promise((resolve) => {
      if (img.complete && img.naturalHeight > 0) {
        resolve({
          width: img.naturalWidth,
          height: img.naturalHeight
        });
      } else {
        img.addEventListener('load', function onLoad() {
          resolve({
            width: img.naturalWidth,
            height: img.naturalHeight
          });
          img.removeEventListener('load', onLoad);
        });
        
        // Fallback if image fails to load
        img.addEventListener('error', () => {
          resolve({
            width: 0,
            height: 0
          });
        });
      }
    });
  }
  
  // Get image width based on viewport - MUST MATCH CSS!
  function getImageWidth() {
    const viewportWidth = window.innerWidth;
    
    // MATCH THE CSS BREAKPOINTS EXACTLY
    if (viewportWidth >= 990) {
      return 250; // Desktop - matches .showcase__image width
    } else if (viewportWidth >= 750) {
      return 200; // Tablet - matches .showcase__image width
    } else if (viewportWidth <= 374) {
      return 90; // Very small mobile - matches @media (max-width: 374px)
    } else {
      return 110; // Regular mobile - matches .showcase__image default width
    }
  }
  
  // Check if we're on mobile
  function isMobile() {
    return window.innerWidth < 750;
  }
  
  // Calculate showcase height based on middle image
  async function calculateAndSetHeight() {
    if (!middleImage) {
      setFallbackHeight();
      return;
    }
    
    try {
      // Get actual image dimensions
      const dimensions = await getImageDimensions(middleImage);
      
      if (dimensions.width === 0 || dimensions.height === 0) {
        setFallbackHeight();
        return;
      }
      
      // Get image width based on current viewport
      const imageWidth = getImageWidth();
      
      // Calculate actual rendered height based on aspect ratio
      const aspectRatio = dimensions.height / dimensions.width;
      const imageHeight = imageWidth * aspectRatio;
      
      // Add buffer for animation
      const spreadBuffer = calculateSpreadBuffer(imageWidth);
      const totalHeight = imageHeight + spreadBuffer;
      
      // Set the height
      currentHeight = Math.ceil(totalHeight);
      showcase.style.setProperty('--showcase-height', `${currentHeight}px`);
      showcase.style.height = `${currentHeight}px`;
      
      // Force a reflow to ensure proper rendering
      void showcase.offsetHeight;
      
      // Mark as initialized and trigger first update
      if (!isInitialized) {
        isInitialized = true;
        // Small delay to ensure height is applied
        setTimeout(() => {
          updateSpread(true); // Pass true for initial update
        }, 50);
      }
      
    } catch (error) {
      console.error('Height calculation error:', error);
      setFallbackHeight();
    }
  }
  
  // Calculate how much extra height we need for the spread animation
  function calculateSpreadBuffer(imageWidth) {
    const isMobileView = isMobile();
    
    const bufferMultiplier = isMobileView ? 0.5 : 0.3;
    const verticalBuffer = imageWidth * bufferMultiplier;
    
    const minBuffer = isMobileView ? 60 : 50;
    return Math.max(minBuffer, verticalBuffer);
  }
  
  function setFallbackHeight() {
    const viewportWidth = window.innerWidth;
    let height;
    
    // Set reasonable fallback heights based on screen size
    if (viewportWidth >= 990) {
      height = 350; // Desktop
    } else if (viewportWidth >= 750) {
      height = 300; // Tablet
    } else if (viewportWidth <= 374) {
      height = 200; // Very small mobile
    } else {
      height = 250; // Regular mobile
    }
    
    currentHeight = height;
    showcase.style.setProperty('--showcase-height', `${height}px`);
    showcase.style.height = `${height}px`;
    
    // Mark as initialized
    if (!isInitialized) {
      isInitialized = true;
      setTimeout(() => {
        updateSpread(true);
      }, 50);
    }
  }
  
  // Calculate max spread based on container width
  function calculateMaxSpread() {
    if (!container) return 60;
    
    const containerWidth = container.offsetWidth;
    if (containerWidth === 0) return 60;
    
    // Get current image width
    const imageWidth = getImageWidth();
    const isMobileView = isMobile();
    
    // Calculate available space
    const margin = isMobileView ? 10 : 20;
    const availableWidth = containerWidth - (margin * 2);
    const availableSpreadWidth = Math.max(0, availableWidth - imageWidth);
    
    const itemCount = items.length;
    const itemsPerSide = Math.floor(itemCount / 2);
    
    if (itemsPerSide === 0 || availableSpreadWidth <= 0) {
      return isMobileView ? 30 : 25;
    }
    
    const maxSpreadPerItem = (availableSpreadWidth / 2) / itemsPerSide;
    
    // Adjust spread based on screen size
    if (isMobileView) {
      return Math.max(30, Math.min(100, maxSpreadPerItem));
    } else if (window.innerWidth >= 990) {
      return Math.max(40, Math.min(150, maxSpreadPerItem));
    } else {
      return Math.max(35, Math.min(120, maxSpreadPerItem));
    }
  }
  
  // Update spread animation
  function updateSpread(isInitial = false) {
    if (!container || items.length === 0 || !isInitialized) return;
    
    const rect = showcase.getBoundingClientRect();
    const viewportHeight = window.innerHeight;
    const isMobileView = isMobile();
    
    // Check if showcase is in viewport
    const isInViewport = rect.top < viewportHeight && rect.bottom > 0;
    
    if (isInViewport) {
      const viewportCenter = viewportHeight / 2;
      const showcaseMiddle = rect.top + (rect.height / 2);
      const distanceFromCenter = Math.abs(showcaseMiddle - viewportCenter);
      
      // For initial load, use a smaller max distance to prevent full spread
      const maxDistance = isInitial ? viewportHeight * 0.5 : (isMobileView ? viewportHeight * 0.9 : viewportHeight * 0.8);
      
      const currentProgress = 1 - Math.min(1, distanceFromCenter / maxDistance);
      
      // On initial load, start with minimal spread
      if (isInitial) {
        maxSpreadAchieved = Math.min(0.2, currentProgress);
      } else {
        maxSpreadAchieved = Math.max(maxSpreadAchieved, currentProgress);
      }
      
      const progress = maxSpreadAchieved;
      const easedProgress = easeInOutCubic(progress);
      
      // Calculate animation values
      const middleProgress = Math.min(1, easedProgress * 1.67);
      const middleBlur = 10 * (1 - middleProgress);
      
      // Start spread earlier on mobile
      const spreadStart = isMobileView ? 0.3 : 0.4;
      const spreadProgress = Math.max(0, (easedProgress - spreadStart) * (1 / (1 - spreadStart)));
      
      const maxSpreadPerItem = calculateMaxSpread();
      
      // Update middle item
      if (middleItem) {
        middleItem.style.filter = `blur(${middleBlur}px)`;
        middleItem.style.transform = 'translate(-50%, -50%)';
        middleItem.style.zIndex = '100';
      }
      
      // Update all other items
      items.forEach((item, index) => {
        if (index === middleIndex) return;
        
        const distanceFromMiddle = Math.abs(index - middleIndex);
        const spread = (index - middleIndex) * maxSpreadPerItem * spreadProgress;
        
        // Less scale reduction on mobile
        const maxScaleReduction = isMobileView ? 0.2 : 0.3;
        const baseScale = 1 - (distanceFromMiddle * maxScaleReduction / Math.max(1, middleIndex));
        
        const scaleProgress = spreadProgress * 0.3;
        const currentScale = baseScale + ((1 - baseScale) * scaleProgress);
        
        const opacity = spreadProgress;
        const blur = 10 * (1 - spreadProgress);
        
        // Calculate z-index
        const baseZIndex = 50;
        const distancePriority = middleIndex - distanceFromMiddle;
        const zIndexValue = baseZIndex + distancePriority;
        
        // Apply styles
        item.style.opacity = opacity;
        item.style.filter = `blur(${blur}px)`;
        item.style.transform = `translate(calc(-50% + ${spread}px), -50%) scale(${currentScale})`;
        item.style.zIndex = Math.max(1, zIndexValue);
      });
    } else {
      // Reset when out of view
      if (rect.bottom <= 0 || rect.top >= viewportHeight) {
        maxSpreadAchieved = 0;
        // Don't re-initialize items, just reset spread
        items.forEach((item, index) => {
          if (index === middleIndex) {
            item.style.opacity = '1';
            item.style.filter = 'blur(10px)';
            item.style.transform = 'translate(-50%, -50%)';
            item.style.zIndex = '100';
          } else {
            item.style.opacity = '0';
            item.style.filter = 'blur(10px)';
            item.style.transform = 'translate(-50%, -50%)';
            item.style.zIndex = '1';
          }
        });
      }
    }
  }
  
  function easeInOutCubic(t) {
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
  }
  
  // Initialize - hide all items first
  initializeItems();
  
  // Calculate height immediately
  calculateAndSetHeight();
  
  // Also calculate after images load
  if (middleImage && !middleImage.complete) {
    middleImage.addEventListener('load', function() {
      setTimeout(() => {
        calculateAndSetHeight();
      }, 100);
    });
  }
  
  // Initial update after a short delay
  setTimeout(() => {
    if (!isInitialized) {
      setFallbackHeight();
    }
  }, 500);
  
  // Throttled scroll handler
  let ticking = false;
  window.addEventListener('scroll', function() {
    if (!ticking) {
      requestAnimationFrame(function() {
        updateSpread();
        ticking = false;
      });
      ticking = true;
    }
  });
  
  // Throttled resize handler
  let resizeTimeout;
  window.addEventListener('resize', function() {
    if (isResizing) return;
    
    isResizing = true;
    clearTimeout(resizeTimeout);
    
    resizeTimeout = setTimeout(function() {
      calculateAndSetHeight();
      updateSpread();
      isResizing = false;
    }, 150);
  });
  
  // Recalculate when window loads
  window.addEventListener('load', function() {
    setTimeout(() => {
      calculateAndSetHeight();
    }, 200);
  });
});